export default __webpack_public_path__ + "static/media/10.b5a07388.jpg";